/**
 * Which toasts are on screen after a new one arrives.
 *
 * The stack exists so a failure is never pushed off screen by whatever comes next (Akhil,
 * 2026-09-17). But every confirmation stacked too, so pricing a dozen lines from our own stock in
 * a row (RENQ-2026-00167, 2026-11-03) piled a dozen "Priced from our own stock…" toasts over the
 * table until they filled the screen.
 *
 * So:
 *  - A confirmation replaces the confirmations already showing. Only the newest one is worth
 *    reading.
 *  - A failure is never removed by a confirmation. The same failure twice shows once, and at most
 *    `MAX_FAILURES` show together, oldest dropped first.
 */

import { isFailure } from './toastDuration'

export interface QueuedToast {
  id: number
  text: string
}

const MAX_FAILURES = 4

export function pushToast(list: readonly QueuedToast[], next: QueuedToast): QueuedToast[] {
  if (!isFailure(next.text)) return [...list.filter((t) => isFailure(t.text)), next]
  const kept = list.filter((t) => t.text !== next.text)
  const failures = kept.filter((t) => isFailure(t.text))
  const drop = new Set(failures.slice(0, Math.max(0, failures.length - (MAX_FAILURES - 1))).map((t) => t.id))
  return [...kept.filter((t) => !drop.has(t.id)), next]
}
